import React, { useEffect, useState } from 'react';
import { resolveImageUrl } from '../../lib/branding';

/**
 * Renders an img with proactive URL normalization and one-shot onError fallback.
 * Returns null (or onFailed render) when src is empty or both primary and fallback fail.
 */
export function ResilientImg({ src, fallback = null, onFailed, alt = '', ...props }) {
  const [current, setCurrent] = useState(() => resolveImageUrl(src, fallback));

  useEffect(() => {
    setCurrent(resolveImageUrl(src, fallback));
  }, [src, fallback]);

  if (!current) {
    return onFailed ? onFailed() : null;
  }

  return (
    <img
      {...props}
      src={current}
      alt={alt}
      onError={() => {
        if (fallback && current !== fallback) {
          setCurrent(fallback);
        } else {
          setCurrent(null);
        }
      }}
    />
  );
}
